<template>
    <div>
        <h1>개인정보 제공 동의(의료 및 공공기관-보건의료정보전송자)</h1>
        <h3>1. 개인정보를 제공받는 자</h3>
        가천대 길병원, 강남세브란스병원, 강릉아산병원, 강북삼성병원, 건국대학교병원, 건양대학교병원, 경북대학교병원, 경상국립대병원, 경희의료원, 계명대학교 동산병원, 고려대학교 구로병원, 고려대학교 안산병원, 고려대학교 안암병원, 고신대학교복음병원, 단국대학교병원, 대구가톨릭대학교병원, 동아대학교병원, 부산대학교병원, 분당서울대병원, 삼성서울병원, 삼성창원병원, 서울대학교병원, 서울성모병원, 서울아산병원, 성빈센트병원, 순천향대학교 부천병원, 신촌세브란스병원, 아주대학교병원, 양산부산대학교병원, 영남대학교병원, 울산대학교병원, 원광대학교병원, 원주세브란스병원, 이대목동병원, 인제대학교 부산백병원, 인천성모병원, 인하대학교병원, 전남대학교병원, 전북대학교병원, 조선대학교병원, 중앙대학교병원, 충남대학교병원, 충북대학교병원, 칠곡경북대학교병원, 한림대학교 성심병원, 한양대학교병원, 화순전남대학교병원, 가톨릭대학교 대전성모병원, 가톨릭대학교 여의도성모병원, 가톨릭대학교 은평성모병원, 가톨릭대학교 의정부성모병원, 강동경희대학교의대병원, 강원대학교병원, 강원특별자치도강릉의료원, 경상남도마산의료원, 경상북도안동의료원, 경상북도포항의료원, 계명대학교대구동산병원, 국민건강보험공단일산병원, 노원을지대학교병원, 대전을지대학교병원, 동래봉생병원, 부천세종병원, 분당차병원, 빛고을전남대학교병원, 서울특별시보라매병원, 서울특별시서울의료원, 세종충남대학교병원, 순천향대학교 구미병원, 순천향대학교 서울병원, 순천향대학교 천안병원, 연세대학교 용인세브란스병원, 울산병원, 의정부을지대학교병원, 이화여자대학교의과대학부속서울병원, 인제대학교 해운대백병원, 제주대학교병원, 충청남도 공주의료원, 충청남도 천안의료원, 충청북도 청주의료원, 충청북도 충주의료원, 한양대학교구리병원, 국민건강보험공단, 건강보험심사평가원, 질병관리청<br>
        <h3>2. 제공되는 정보</h3>
        CI, 전송요구서<br>
        <h3>3. 제공 목적</h3>
        본인확인 및 개인정보의 전송<br>
        <h3>4. 제공받는 자의 보유 및 이용기간</h3>
        본인확인 및 개인정보 전송 목적 달성 시까지<br><br>
        정보주체는 위 개인정보의 제3자 제공을 거부할 수 있습니다. 그러나 그 경우 본인의료정보 통합조회 및 데이터 분석 서비스를 이용할 수 없습니다.
    </div>
</template>

<script>
export default {
    name: 'mydataInfoTransmitter'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/mydata/InfoTransmitter.vue